import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ChangeRequestStateSlice {
  changeRequestId: string | null;
  revokeAPICalls: boolean;
  currentActionItemId: string | null;
}

const initialState: ChangeRequestStateSlice = {
  changeRequestId: null,
  revokeAPICalls: false,
  currentActionItemId: null,
};

const changeRequestStateSlice = createSlice({
  name: 'changeRequestState',
  initialState,
  reducers: {
    setChangeRequestId: (state, action: PayloadAction<string | null>) => {
      state.changeRequestId = action.payload;
    },
    setRevokeAPICalls: (state, action: PayloadAction<boolean>) => {
      state.revokeAPICalls = action.payload;
    },
    setCurrentActionItemId: (state, action: PayloadAction<string | null>) => {
      state.currentActionItemId = action.payload;
    },
    resetChangeRequestState: () => {
      return initialState;
    },
  },
});

export const {
  setChangeRequestId,
  setRevokeAPICalls,
  setCurrentActionItemId,
  resetChangeRequestState,
} = changeRequestStateSlice.actions;

export default changeRequestStateSlice.reducer;
